module.exports = __webpack_public_path__ + "static/media/cc.1994d839.webp";